import React from 'react'
import glossariy from '../fayl/glossariy.pdf'
import { Button } from 'antd'

export const Glossariy = () => {
    return (
        <div>
            <Button className='button'>
                <a href={glossariy}>Glossariy</a>
            </Button>
        </div>
    )
}
